import { Box } from "@govlaunch/web";
import React from "react";

export default function BundleCardBackground() {
  return (
    <Box
      position="absolute"
      border="1px"
      borderColor="gray.400"
      width="100%"
      height="100%"
      top="-4px"
      left="-8px"
      borderRadius="12px 12px 4px 12px"
      bg="white"
    />
  );
}
